// extracted by mini-css-extract-plugin
export default {"MenuButton":"EnlilTable_MenuButton__NQiCH","Standard":"EnlilTable_Standard__-3Lnr","SelectPage":"EnlilTable_SelectPage__4Qh6U"};